<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big5"><strong>SiDE EFFECTS</strong></span><br/><br/><br/></p>
<p class="center"><strong><span class="big6">Amy Goldman Koss</span></strong><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780312602765_L02.png"/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780312602765_L01.png"/></p>
<p class="center2"><strong><span class="small1">SQUARE</span></strong></p>
<p class="center3"><strong><span class="small1">FISH</span></strong></p>
<p class="center3"><span class="small"><strong>ROARING BROOK PRESS</strong></span></p>
<p class="center3"><span class="small"><strong>NEW YORK</strong></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312602765_epub_tp_r1.vue?ac0b6f00